// pages/CheckoutPage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, setDoc, serverTimestamp } from "firebase/firestore";
import { firebaseApp } from "../firebase/firebaseApp";
import RequirePlanSelected from "../components/guards/RequirePlanSelected";
import RequireRegistered from "../components/guards/RequireRegistered";
import { useUserDoc } from "../hooks/useUserDoc";
import { GlassPanel } from "../components/ui/GlassPanel";
export default function CheckoutPage() {
  const navigate = useNavigate();
  const auth = getAuth(firebaseApp);
  const db = getFirestore(firebaseApp);
  const { data } = useUserDoc();
  const plan = data?.plan;
  async function fakeSuccess(paymentMethod = "card") {
    const u = auth.currentUser;
    await setDoc(
      doc(db, "lungform_users", u.uid),
      {
        entitlements: {
          active: true,
          sku: plan?.kind || null,
          interval: plan?.interval || null,
          currency: plan?.currency || null,
          price: plan?.price ?? null,
          source: "app-checkout-demo",
          activatedAt: serverTimestamp(),
          updatedAt: serverTimestamp(),
        },
        payment: {
          lastCheckout: {
            status: "succeeded",
            method: paymentMethod, // ← "card" | "apple_pay" | etc
            processor: "demo", // replace with "stripe" when wired
            plan,
            completedAt: serverTimestamp(),
          },
        },
        onboarding: { step: "paymentComplete", paymentAt: serverTimestamp() },
      },
      { merge: true }
    );
    navigate("/home", { replace: true });
  }

  return (
    <RequirePlanSelected>
      <RequireRegistered>
        <div className="max-w-lg w-full p-4 flex flex-col gap-4">
          <h1 className="supertitle-text">Checkout</h1>

          {/* Plan summary mirrors PaymentSelectPage text */}
          <GlassPanel className="overflow-hidden rounded-2xl">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-typography/60">Selected plan</p>
                <h2 className="text-lg font-semibold">
                  {plan?.title ||
                    (plan?.kind === "subscription"
                      ? "Subscribe & Track"
                      : "One-time")}
                </h2>
              </div>
              <div className="text-right">
                <div className="text-xl font-semibold">
                  {plan?.currency === "GBP" ? "£" : ""}
                  {plan?.price}
                  {plan?.cadenceLabel ? (
                    <span className="text-sm text-typography/60">
                      {" "}
                      {plan?.cadenceLabel}
                    </span>
                  ) : null}
                </div>
              </div>
            </div>
          </GlassPanel>
          {/* TODO: Replace with a real Checkout session */}
          <div className="grid grid-cols-2 gap-3">
            <button
              className="primary-button"
              onClick={() => fakeSuccess("card")}
            >
              Pay with Card (demo)
            </button>
            <button
              className="primary-button !bg-black"
              onClick={() => fakeSuccess("apple_pay")}
            >
              Apple Pay (demo)
            </button>
          </div>
        </div>
      </RequireRegistered>
    </RequirePlanSelected>
  );
}
